<template>
  <div class="entities-extraction pb-3">
    <v-layout>
      <v-flex xs3>
        <p>Entity name</p>
      </v-flex>
      <v-flex xs3 class="">
        <p>Save parameter to</p>
      </v-flex>
      <v-flex xs3 class="">
        <p>Default value</p>
      </v-flex>
      <v-flex xs3 class="">
        <p>Required</p>
      </v-flex>
    </v-layout>
    <v-expansion-panel expand :value="panel">
      <v-expansion-panel-content :lazy="true" v-for="(entity, index) in entities" class="entity-card delete-wrapper">
        <template v-slot:header >
          <v-layout class="align-center">
            <v-flex xs3>
              <p>{{entity.entityName}}</p>
            </v-flex>
            <v-flex xs3 class="">
              <p>{{entity.saveTo}}</p>
            </v-flex>
            <v-flex xs3 class="pl-4">
              <p>{{entity.defaultValue}}</p>
            </v-flex>
            <v-flex xs3 class="pl-5">
              <p>{{entity.required}}</p>
            </v-flex>
          </v-layout>
          <v-btn
            @click="deleteEntity(index)"
            fab small color=""
            class="delete-button"
          ><v-icon small color="#666">delete_outline</v-icon></v-btn>
        </template>
        <v-layout wrap>
          <v-flex xs3>
            <label for="">Name</label>
            <v-text-field
              v-model="entity.entityName"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs3>
            <label for="">Save parameter to</label>
            <v-text-field
              v-model="entity.saveTo"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs3>
            <label for="">Default value</label>
            <v-text-field
              v-model="entity.defaultValue"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs3 class="">
            <label for="">Required</label>
            <v-switch
              v-model="entity.required"
            ></v-switch>
          </v-flex>
          <v-flex xs4>
            <label for="">Question</label>
            <v-text-field
              v-model="entity.question"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <label for="">Error message</label>
            <v-text-field
              v-model="entity.errorMessage"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <label for="">Regex</label>
            <v-text-field
              v-model="entity.regex"
              outline
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-btn  class="add-random-replay font-weight-bold"   color="third" round  @click="addNewEntity"><v-icon>add</v-icon> Add Another Entity</v-btn>
  </div>
</template>

<script>
  export default {
    name: "entities",
    props: {
      entities: {
        type: Array,
        default: ()=> {
          return [

          ]
        }
      }
    },
    data() {
      return {
        panel: -1
      }
    },
    methods: {
      addNewEntity() {
        this.entities.push(
          {
            entityName: 'Entity name',
            saveTo: 'Attribute name',
            required: true,
            defaultValue: 'default value',
            regex: '',
            question: '',
            errorMessage: ''
          }
        )
        this.$emit('updateEntities', this.entities )
        this.$forceUpdate();
      },
      deleteEntity(index) {
        this.entities.splice(index,1)
        this.$emit('updateEntities', this.entities )
        this.$forceUpdate();
      }
    },
    watch : {
      entities: {
        handler(){
          this.$emit('updateEntities', this.entities )
        },
        deep: true
      },
    }
  }
</script>

<style scoped>

</style>
